let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2WxDq")).then(() => parcelRequire('j0q2q'));